/**
 * Programs Built for Every Stage - Variant 2
 * Heading max 2 lines, styling via curly braces.
 * Categories optional (Use categories toggle); when on, max 10, default category supported. Name max 25 char.
 * Cards: image, title (1 line), subtitle (wraps); optional Duration, Format, What You'll Gain; modal body + per-card footer CTA text (falls back to section default).
 */

export const PROGRAM_CARDS_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    title: "",
    subtitle: "",
    priority: 1,
    modal_cta_background_start_color: "",
    modal_cta_background_end_color: "",
    modal_cta_background_angle: "",
    modal_cta_text_color: "",
    modal_cta_text: "",
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    { 
      fieldName: "desktop_background_color", 
      label: "Desktop Background Color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "e.g. #FFFFFF", 
      required: false, 
      defaultValue: "#FFFFFF" 
    },
    { 
      fieldName: "mobile_background_color", 
      label: "Mobile Background Color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "e.g. #FFFFFF", 
      required: false, 
      defaultValue: "#FFFFFF" 
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select variant",
      required: false,
      defaultValue: "variant_3",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "font_family_variant",
      label: "Font Family",
      value: "variant_2",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font family",
      required: false,
      defaultValue: "variant_2",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    { 
      fieldName: "gradient_color_1", 
      label: "Gradient Color 1", 
      value: "#5345C3", 
      valueType: "string", 
      filedType: "COLOR", 
      required: false, 
      defaultValue: "#5345C3" 
    },
    { 
      fieldName: "gradient_color_2", 
      label: "Gradient Color 2", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      required: false, 
      defaultValue: "#000000" 
    },
    { 
      fieldName: "gradient_color_3", 
      label: "Gradient Color 3", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      required: false, 
      defaultValue: "#000000" 
    },
    { 
      fieldName: "gradient_color_4", 
      label: "Gradient Color 4", 
      value: "#00D4EB", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Gradient Color 4",
      required: false, 
      defaultValue: "#00D4EB" 
    },
    { 
      fieldName: "pre_title", 
      label: "Pre Title (max 20 characters)", 
      value: "Programs Built for", 
      valueType: "string", 
      filedType: "INPUT",
      placeholder: "Max 20 characters", 
      required: false, 
      defaultValue: "Programs Built for" 
    },
    { 
      fieldName: "pre_title_color", 
      label: "Pre Title Color", 
      value: "#222222CC", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Pre Title Color",
      required: false, 
      defaultValue: "#222222CC" 
    },
    { 
      fieldName: "title", 
      label: "Title (main heading) (max 20 characters)", 
      value: "Every Stage", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Max 20 characters",
      required: false, 
      defaultValue: "Every Stage" 
    },
    { 
      fieldName: "title_start_color", 
      label: "Title Gradient Start Color", 
      value: "#342B7C", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Title Gradient Start Color",
      required: false, 
      defaultValue: "#342B7C" 
    },
    { 
      fieldName: "title_end_color", 
      label: "Title Gradient End Color", 
      value: "#02A7B6", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Title Gradient End Color",
      required: false, 
      defaultValue: "#02A7B6" 
    },
    { 
      fieldName: "title_gradient_angle", 
      label: "Title Gradient Angle", 
      value: "180deg", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Gradient Angle",
      required: false, 
      defaultValue: "180deg" 
    },
    { 
      fieldName: "cta_text", 
      label: "CTA Button Text", 
      value: "View All Course", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter CTA Button Text",
      required: false, 
      defaultValue: "View All courses" 
    },
    { 
      fieldName: "cta_text_color", 
      label: "CTA Text Color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter CTA Text Color",
      required: false, 
      defaultValue: "#FFFFFF" 
    },
    { 
      fieldName: "cta_background_start_color", 
      label: "CTA Background Start Color", 
      value: "#02A7B6", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter CTA Background Start Color",
      required: false, 
      defaultValue: "#02A7B6" 
    },
    { 
      fieldName: "cta_background_end_color", 
      label: "CTA Background End Color", 
      value: "#342B7C", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter CTA Background End Color",
      required: false, 
      defaultValue: "#342B7C" 
    },
    { 
      fieldName: "cta_background_angle", 
      label: "CTA Background Angle", 
      value: "180deg", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Gradient Angle",
      required: false, 
      defaultValue: "180deg" 
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_variant",
      label: "CTA Button Style",
      value: "variant_2",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select CTA button style",
      required: false,
      defaultValue: "variant_2",
      options: [
        {
          label: "Variant 1 — solid + heading scale",
          value: "variant_1",
        },
        {
          label: "Variant 2 — gradient + arrow fallback",
          value: "variant_2",
        },
      ],
    },
    // {
    //   fieldName: "use_categories",
    //   label: "Use categories",
    //   value: true,
    //   valueType: "boolean",
    //   filedType: "TOGGLE",
    //   required: false,
    //   defaultValue: true,
    // },
    {
      fieldName: "show_features",
      label: "Show features on program cards (Duration, Format, What You'll Gain)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Animate section on scroll",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      required: false,
      defaultValue: true,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    { 
      fieldName: "name", 
      label: "Category Name", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Category Name",
      required: true,  
      defaultValue: "" 
    },
    { 
      fieldName: "order_index", 
      label: "Display Order", 
      value: 1, 
      valueType: "number", 
      filedType: "INPUT", 
      placeholder: "Enter Display Order",
      required: true, 
      defaultValue: 1 
    },
    { 
      fieldName: "is_default", 
      label: "Default Category (shows all courses)", 
      value: false, 
      valueType: "boolean", 
      filedType: "TOGGLE", 
      placeholder: "Show all courses",
      required: false, 
      defaultValue: false 
    },
    { 
      fieldName: "text_color", 
      label: "Category Text Color", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Category Text Color",
      required: false, 
      defaultValue: "#000000" 
    },
    { 
      fieldName: "background_color", 
      label: "Category Background Color", 
      value: "#ffffff", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Category Background Color",
      required: false, 
      defaultValue: "#ffffff" 
    },
    { 
      fieldName: "active_text_color", 
      label: "Active Category Text Color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Active Category Text Color",
      required: false, 
      defaultValue: "#FFFFFF" 
    },
    { 
      fieldName: "active_background_color", 
      label: "Active Category Background Color", 
      value: "#02A7B6", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Active Category Background Color",
      required: false, 
      defaultValue: "#02A7B6" 
    },
    { 
      fieldName: "border_color", 
      label: "Inactive Tab Border Color", 
      value: "#00000066", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Inactive Tab Border Color",
      required: false, 
      defaultValue: "#00000066" 
    },
  ],


  CARD_TABLE_FIELDS_CONFIG: [
    { 
      header: "Title (max 20 characters)", 
      fieldName: "title", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Max 20 characters",
      required: true, 
    },
    { 
      header: "Title Color", 
      fieldName: "title_color", 
      value: "#342B7C", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Card Title Color",
      required: false, 
      defaultValue: "#342B7C" 
    },
    { 
      header: "Subtitle (max 2 lines; max 100 characters)", 
      fieldName: "subtitle", 
      value: "", 
      valueType: "string", 
      filedType: "TEXT_AREA", 
      placeholder: "Max 100 characters",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Subtitle Color", 
      fieldName: "subtitle_color", 
      value: "#00000099", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Subtitle Color",
      required: false, 
      defaultValue: "#00000099" 
    },
    { 
      header: "Image", 
      fieldName: "image", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      placeholder: "Upload Card Image",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Image Alt", 
      fieldName: "image_alt", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Image Alt",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Duration Heading", 
      fieldName: "duration_heading", 
      value: "Duration", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Duration Heading",
      required: false, 
      defaultValue: "Duration" 
    },
    { 
      header: "Duration Heading Color", 
      fieldName: "duration_heading_color", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "Enter Duration Heading Color",
      required: false, 
      defaultValue: "#000000" 
    },
    { 
      header: "Duration Text (max 1 line)", 
      fieldName: "duration_text", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter Duration Text",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Duration Text Color", 
      fieldName: "duration_text_color", 
      value: "#00000099", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Duration Text Color",
      required: false, 
      defaultValue: "#00000099"
    },
    { 
      header: "Duration Icon", 
      fieldName: "duration_icon", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      maxLength: 1,
      placeholder: "Upload Duration Icon",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Duration Icon Alt", 
      fieldName: "duration_icon_alt", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Enter Duration Icon Alt",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Format Heading", 
      fieldName: "format_heading", 
      value: "Format", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter Format Heading",
      required: false, 
      defaultValue: "Format" 
    },
    { 
      header: "Format Heading Color", 
      fieldName: "format_heading_color", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Format Heading Color",
      required: false, 
      defaultValue: "#000000" 
    },
    { 
      header: "Format Text", 
      fieldName: "format_text", 
      value: "Live sessions", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter Format Text",
      required: false, 
      defaultValue: "Live sessions " 
    },
    { header: "Format Text Color", 
      fieldName: "format_text_color", 
      value: "#00000099", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Format Text Color",
      required: false, 
      defaultValue: "#00000099" 
    },
    { header: "Format Icon", 
      fieldName: "format_icon", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      maxLength: 1,
      placeholder: "Upload Format Icon",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Format Icon Alt", 
      fieldName: "format_icon_alt", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter Format Icon Alt",
      required: false, 
      defaultValue: "" 
    },
    { header: "What You'll Gain Heading (max 50 characters)", 
      fieldName: "what_you_gain_heading", 
      value: "What You'll Gain", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Max 50 characters",
      required: false, 
      defaultValue: "What You'll Gain" 
    },
    { header: "What You'll Gain Heading Color", 
      fieldName: "what_you_gain_heading_color", 
      value: "#000000", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter What You'll Gain Heading Color",
      required: false, 
      defaultValue: "#000000" 
    },
    { header: "What You'll Gain Text (max 100 characters)", 
      fieldName: "what_you_gain_text", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Max 100 characters",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "What You'll Gain Text Color", 
      fieldName: "what_you_gain_text_color", 
      value: "#00000099", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter What You'll Gain Text Color",
      required: false, 
      defaultValue: "#00000099" 
    },
    { header: "What You'll Gain Icon", 
      fieldName: "what_you_gain_icon", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      maxLength: 1,
      placeholder: "Upload What You'll Gain Icon",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "What You'll Gain Icon Alt", 
      fieldName: "what_you_gain_icon_alt", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter What You'll Gain Icon Alt",
      required: false, 
      defaultValue: "" 
    },
    {
      header: "Info",
      fieldName: "_cms_text_block_modal_lead_hint",
      value: "",
      valueType: "string",
      filedType: "TEXT_BLOCK",
      description:
        "If modal title, modal description, and modal CTA text are all left empty, the lead drop form will open by default when visitors tap Explore (the detail modal is skipped).",
      required: false,
      defaultValue: "",
    },
    { 
      header: "Modal Title (max 40 characters)", 
      fieldName: "modal_title", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Max 40 characters",
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Modal Title Color", 
      fieldName: "modal_title_color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Modal Title Color",
      required: false, 
      defaultValue: "#FFFFFF" 
    },
    { 
      header: "Modal Title Background Start", 
      fieldName: "modal_title_background_start_color", 
      value: "#342B7C", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Modal Title Background Start Color",
      required: false, 
      defaultValue: "#342B7C" 
    },
    { 
      header: "Modal Title Background End", 
      fieldName: "modal_title_background_end_color", 
      value: "#02A7B6", 
      valueType: "string", 
      filedType: "COLOR", 
      maxLength: 1,
      placeholder: "Enter Modal Title Background End Color",
      required: false, 
      defaultValue: "#02A7B6" 
    },
    { 
      header: "Modal Title Background Angle", 
      fieldName: "modal_title_background_angle", 
      value: "90deg", 
      valueType: "string", 
      filedType: "INPUT", 
      maxLength: 1,
      placeholder: "Enter Modal Title Background Angle",
      required: false, 
      defaultValue: "90deg" 
    },
    { 
      header: "Modal Description", 
      fieldName: "modal_description", 
      value: "", 
      valueType: "string", 
      filedType: "RICH_TEXT_EDITOR", 
      placeholder: "Modal body text (rich text)",
      required: false, 
      defaultValue: "" 
    },
    {
      header: "Modal footer CTA text",
      fieldName: "modal_cta_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Apply Now (empty = section default)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Modal CTA background start",
      fieldName: "modal_cta_background_start_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = section CTA start color",
      required: false,
      defaultValue: "",
    },
    {
      header: "Modal CTA background end",
      fieldName: "modal_cta_background_end_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = section CTA end color",
      required: false,
      defaultValue: "",
    },
    {
      header: "Modal CTA gradient angle",
      fieldName: "modal_cta_background_angle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 180deg (empty = section CTA angle)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Modal CTA text color",
      fieldName: "modal_cta_text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = section CTA text color",
      required: false,
      defaultValue: "",
    },
    { 
      header: "Button Text", 
      fieldName: "button_text", 
      value: "Apply Now", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "e.g. Explore Course", 
      required: false, 
      defaultValue: "Apply Now" 
    },
    {
      header: "Explore button — text color",
      fieldName: "button_text_color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Label and icon (border uses background color, not this)",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      header: "Explore button — background (border matches this color)",
      fieldName: "button_background_color",
      value: "transparent",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Fill and border; transparent = no fill / no visible border ring",
      required: false,
      defaultValue: "transparent",
    },
    { 
      header: "Button Icon", 
      fieldName: "button_icon", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      placeholder: "Optional icon", 
      required: false, 
      defaultValue: "" 
    },
    { 
      header: "Button Icon Alt", 
      fieldName: "button_icon_alt",
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Alt text", 
      required: false, 
      defaultValue: "Apply Now" },
    {
      header: "Brochure button — label",
      fieldName: "brochure_button_text",
      value: "Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Brochure",
      required: false,
      defaultValue: "Brochure",
    },
    {
      header: "Brochure button — text color (border matches this color)",
      fieldName: "brochure_button_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Label color on the brochure button",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Brochure button — background",
      fieldName: "brochure_button_background_color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Fill and border use the same color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      header: "Brochure button — icon",
      fieldName: "brochure_button_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional; defaults to arrow if empty",
      required: false,
      defaultValue: "",
    },
    {
      header: "Brochure button — icon alt",
      fieldName: "brochure_button_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      header: "Brochure — file URL (button hidden if empty)",
      fieldName: "brochure_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "PDF or file URL; required to show the brochure button",
      required: false,
      defaultValue: "",
    },
    { 
      header: "Priority", 
      fieldName: "priority", 
      value: 1, 
      valueType: "number", 
      filedType: "INPUT", 
      required: true, 
      defaultValue: 1 
    },
  ],
};
